/**
 * Configuración centralizada de SweetAlert2 con soporte para React
 * Este módulo proporciona una instancia de SweetAlert2 configurada con withReactContent
 * para permitir el uso de componentes React dentro de las alertas.
 */

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

// Crear instancia de SweetAlert2 con soporte para React
export const MySwal = withReactContent(Swal);

// Re-exportar tipos útiles
export type { SweetAlertIcon } from 'sweetalert2';

// Exportar la instancia base por si se necesita acceso directo
export { Swal };

// Exportar por defecto la instancia con React
export default MySwal;
